// components
import { RForm, RTable, RBtnAction } from '@/components/reusable_components/next'
import { beforeRouteEnter } from '@/mixins/reusable_mixins/permissions'
import Translator from '@/services/translator'

// models
import DispatchRequestModel from '@/models/Warehouse/WhDispatchRequest'
import DispatchRequestService from '@/services/api/Warehouse/WhDispatchRequest'
import DispatchRequestFilters from '@/views/Warehouse/WhDispatchRequest/list/filters'
import DispatchRequestHeaders from '@/views/Warehouse/WhDispatchRequest/list/headers'

// view
export default {
  name: 'dispatch-request-pending',
  components: {
    RBtnAction,
    RForm,
    RTable,
  },
  computed: {

    /**
     * 
     */
    confirmProps() {
      return {
        fields: [
          {
            name: 'auth_code',
            type: 'password-field',
            flex: {
              xs12: true,
            },
            props: {
              label: 'Código del que confirma'
            },
          },
          {
            name: 'comment',
            type: 'textarea',
            flex: {
              xs12: true,
            },
            props: {
              label: 'Cómentario de rectificación',
              placeholder: 'Rellenar solo para rectificación',
            },
          },
        ]
      }
    },

    /**
     * 
     */
    revisionProps() {
      return {
        fields: [
          {
            name: 'package_number',
            type: 'float-field',
            flex: {
              sm6: true,
              xs12: true,
            },
            props: {
              label: 'Número de Bultos'
            },
          },
          {
            name: 'package_cube',
            type: 'text-field',
            flex: {
              sm6: true,
              xs12: true,
            },
            props: {
              label: 'Cubo '
            },
          },
          {
            name: 'auth_code',
            type: 'password-field',
            flex: {
              xs12: true,
            },
            props: {
              label: 'Código del que arma'
            },
          },
        ]
      }
    },

    /**
     * Table props
     *
     * @return     {Object}  the table props
     */
    tableProps() {
      return {
        attachParams: {
          batch_id: '1'
        },
        filters: DispatchRequestFilters,
        headers: DispatchRequestHeaders,
        paramFilter: {
          //g_state_id: [23, 40, 24]
        },
        mapperFilter: this.parseFilter,
        service: new DispatchRequestService().toList(),
      }
    },
  },
  data() {
    return {
      dialogs: {
        confirm: false,
        revision: false,
      },
      revisionData: {},
      selected: null,
    }
  },
  methods: {

    /**
     * Arm dispatch request
     *
     * @return     {Promise}  the arm request promise
     */
    applyArm() {
      return this
        .showProgressSnackbarState()
        .then(this.toArm)
        .then(this.showSuccessArm)
        .then(this.refresh)
        .catch(this.toError)
    },

    /**
     * Confirm dispatch request
     *
     * @return     {Promise}  the confirm request promise
     */
    applyConfirm() {
      return this
        .toWaitConfirm(true)
        .then(this.toConfirm)
        .then(this.showSuccessConfirm)
        .then(this.refresh)
        .catch(this.toError)
        .then(this.toWaitConfirm)
    },

    /**
     * Delete dispatch request
     *
     * @return     {Promise}  the confirm request promise
     */
    applyDelete() {
      return this
        .showProgressSnackbarState()
        .then(this.toDelete)
        .then(this.showSuccessDelete)
        .then(this.refresh)
        .catch(this.toError)
    },

    /**
     * Print dispatch request ticket
     *
     * @return     {Promise}  the confirm request promise
     */
    applyPrintTicket() {
      return this
        .showProgressSnackbarState()
        .then(this.toFindSelected)
        .then(this.toPrintTicket)
        .then(this.showSuccessPrintTicket)
        .catch(this.toError)
    },

    /**
     * Rectify dispatch request
     *
     * @return     {Promise}  the rectify request promise
     */
    applyRectify() {
      return this
        .toWaitConfirm(true)
        .then(this.toRectify)
        .then(this.showSuccessRectify)
        .then(this.refresh)
        .catch(this.showErrorRectify)
        .then(this.toWaitConfirm)
    },

    /**
     * Confirm dispatch request
     *
     * @return     {Promise}  the confirm request promise
     */
    applyRevision() {
      return this
        .toWaitRevision(true)
        .then(this.toRevision)
        .then(this.showSuccessRevision)
        .then(this.refresh)
        .catch(this.showError)
        .then(this.toWaitRevision)
    },

    /**
     * { function_description }
     *
     * @param      {<type>}  filter  The filter
     * @return     {Object}  { description_of_the_return_value }
     */
    parseFilter(filter) {
        return {
            ...filter,
            creation_date_day_min: undefined,
            creation_date_day_max: undefined,
            creation_date_hour_min: undefined,
            creation_date_hour_max: undefined,
            created_at_min: 
                filter.creation_date_day_min ?
                    filter.creation_date_hour_min ?
                        `${filter.creation_date_day_min} ${filter.creation_date_hour_min}`
                        :
                        `${filter.creation_date_day_min} 00:00`
                    :
                    undefined,
            created_at_max: 
                filter.creation_date_day_max ?
                    filter.creation_date_hour_max ?
                        `${filter.creation_date_day_max} ${filter.creation_date_hour_max}`
                        :
                        `${filter.creation_date_day_max} 00:00`
                    :
                    undefined,
        }
    },

    /**
     * Refresh the data table
     *
     * @return     {Promise}  The table refresh request
     */
    refresh() {
      this
        .$refs
        .table
        .refresh()
    },
    showError(error) {
      this.showErrorSnackbar(Translator(DispatchRequestModel, error.response.data))
    },
    showErrorRectify(error) {
      this.showErrorSnackbar(Translator(DispatchRequestModel, error.response.data))
    },
    showDialogConfirm () {
      this.dialogs.confirm = true
    },
    showDialogRevision () {
      this.dialogs.revision = true
    },
    /**
     * Shows the success arm.
     */
    showSuccessArm() {
      this.showSuccessSnackbar('Solicitud de despacho establecida en armando.')
    },

    /**
     * Shows the success confirm.
     */
    showSuccessConfirm() {
      this.showSuccessSnackbar('Solicitud de despacho confirmada.')
      this.dialogs.confirm = false
    },

    /**
     * Shows the success delete.
     */
    showSuccessDelete() {
      this.showSuccessSnackbar('Solicitud de despacho anulada con éxito.')
    },

    /**
     * Shows the success print ticket.
     */
    showSuccessPrintTicket(event) {
      this.showSuccessSnackbar(event.data.message)
    },

    /**
     * Shows the success confirm.
     */
    showSuccessRectify() {
      this.showSuccessSnackbar('Solicitud de despacho rectificada.')
      this.dialogs.confirm = false
    },
    /**
     * Shows the success print ticket.
     */
    showSuccessRevision(event) {
      this.showSuccessSnackbar('Solicitud de despacho establecida en revision exitosamente.')
      this.dialogs.revision = false
      this.revisionData = {}
    },

    /**
     * Shows the warning arm.
     */
    showWarningArm() {
      this.showWarningSnackbar({
        title: `¿Deseas armar la solicitud #${this.selected.id}?`,
        message: 'Una vez armada no se puede retroceder.',
        confirm: 'armar',
      })
    },

    /**
     * Shows the warning confirm.
     */
    showWarningConfirm() {
      this.showWarningSnackbar({
        title: `¿Deseas confirmar la solicitud #${this.selected.id}?`,
        message: 'Una vez confirmada no se puede retroceder.',
        confirm: 'confirmar',
        color: 'secondary',
      })
    },

    /**
     * Shows the warning delete.
     */
    showWarningDelete() {
      this.showWarningSnackbar({
        title: `¿Deseas eliminar la solicitud #${this.selected.id}?`,
        message: 'Una vez eliminada no se puede recuperar.',
        confirm: 'eliminar',
        color: 'error',
      })
    },

    /**
     * Shows the warning print ticket.
     */
    showWarningPrintTicket() {
      this.showWarningSnackbar({
        title: `¿Deseas imprimir la solicitud #${this.selected.id}?`,
        message: 'Se incluira el detalle del cliente y los items de la solicitud.',
        confirm: 'imprimir',
        color: 'print',
      })
    },

    /**
     * Submit arm dispatch request
     *
     * @param      {Object}  event   The submit payload
     */
    submitArm(event) {
      this.setSelected(event.item).then(this.showWarningArm)
    },

    /**
     * Submit confirm dispatch request
     *
     * @param      {Object}  event   The submit payload
     */
    submitConfirm(event) {
      this.setSelected(event.item).then(this.showDialogConfirm)
    },

    /**
     * Submit delete dispatch request
     *
     * @param      {Object}  event   The submit payload
     */
    submitDelete(event) {
      this.setSelected(event.item).then(this.showWarningDelete)
    },

    /**
     * Submit print ticket dispatch request
     *
     * @param      {Object}  event   The submit payload
     */
    submitPrintTicket(event) {
      this.setSelected(event.item).then(this.showWarningPrintTicket)
    },

    /**
     * Submit receive dispatch request
     *
     * @param      {Object}  event   The submit payload
     */
    submitReceive(event) {
      this.$router.push({ name: 'wh-dispatch-request-receive', params: { id: event.item.id } })
    },

    /**
     * Submit revision dispatch request
     *
     * @param      {Object}  event   The submit payload
     */
    submitRevision(event) {
      this.setSelected(event.item).then(this.showDialogRevision)
    },

    /**
     * Submit update dispatch request
     *
     * @param      {Object}  event   The submit payload
     */
    submitUpdate(event) {
      this.$router.push({
        name: 'dispatch-request-update',
        params: { 
          id: event.item.id 
        },
        query: {
          from: 'dispatch-request-list'
        }
      })
    },

    /**
     * Returns an arm request of the selected item.
     *
     * @return     {Promise}  Arm request of the item.
     */
    toArm() {
      return this
        .selected
        .inArmed()
        .sync()
    },

    /**
     * Returns a confirm request of the selected item.
     *
     * @return     {Promise}  Confirm request of the item.
     */
    toConfirm(data) {
      return this
        .selected
        .confirm()
        .sync(data)
    },

    /**
     * Returns a delete request of the selected item.
     *
     * @return     {Promise}  Delete request of the item.
     */
    toDelete() {
      return this
        .selected
        .delete()
    },

    /**
     * Catch a error of a dispatch request promise.
     *
     * @param      {Object}  [error={}]  The error.
     * @return     {Promise} The resolve promise of error.
     */
    toError(error = {}) {
      return DispatchRequestService.errorify(error).then(this.showErrorSnackbar)
    },

    /**
     * Returns a find model of the selected item.
     *
     * @return     {Promise}  Find the selected item.
     */
    toFindSelected() {
      return DispatchRequestService
        .model()
        .modeler()
        .find(this.selected.id)
    },

    /**
     * Returns a print ticket request of the selected item.
     *
     * @param      {<type>}  model   The model
     * @return     {Promise} Print ticket request of the item.
     */
    toPrintTicket(model) {
      return model
        .toPrintJob()
        .attach()
    },

    /**
     * Returns a revision request of the selected item.
     *
     * @param      {<type>}  model   The model
     * @return     {Promise} Revision request of the item.
     */
    toRevision(data) {
      return this
        .selected
        .inArmedToRevision()
        .sync(data)
    },
    toRectify(data) {
      return this
        .selected
        .inRevisionToArmed()
        .sync(data)
    },
    toWaitConfirm(value) {
      return this
        .$refs
        .confirm
        .setWait(value)
    },
    toWaitRevision(value) {
      return this
        .$refs
        .revision
        .setWait(value)
    },
  },
  watch: {
    
    /**
     * Liten response confirm of snackbar store state
     *
     * @param      {*}   value   The value
     * @return     {Promise}  { description_of_the_return_value }
     */
    async responseConfirmSnackbar(value) {
      switch (value) {
        case 'armar'    : return this.applyArm()
        case 'confirmar': return this.applyConfirm()
        case 'eliminar' : return this.applyDelete()
        case 'imprimir' : return this.applyPrintTicket()
      }
    },
  },
  beforeRouteEnter: beforeRouteEnter('VIEW_ALL_DISPATCH_REQUEST'),
  beforeMount() {
    this.setTitle('Solicitudes de despacho')
  },
}
